module.exports = __webpack_public_path__ + "static/media/support-faq.aafe6edc.svg";